import { useFormContext } from "react-hook-form";

import { SecretField } from "src/connections/config/shared/SecretField";
import {
  Environment,
  InboundWebhookConnectionConfigInputs,
} from "src/connections/types";

type SecretConfigField =
  | "webhookBasicAuthConfig.login"
  | "webhookBasicAuthConfig.password"
  | "webhookApiKeyConfig.apiKey"
  | "webhookHMACConfig.signingKey"
  | "webhookHMACPersonaConfig.signingKey"
  | "webhookHMACArvaConfig.signingKey"
  | "webhookTruliooHMACHandshakeConfig.signingKey";

type SecretProps = {
  dataLoc?: string;
  secretConfigField: SecretConfigField;
  secretName: string;
  helpText: string;
  isRequired?: boolean;
  isErrored: boolean;
  environment: Environment;
};

export const InboundWebhookSecretField: React.FC<SecretProps> = ({
  dataLoc,
  secretConfigField,
  secretName,
  helpText,
  isRequired,
  isErrored,
  environment,
}) => {
  const { watch, setValue, register } =
    useFormContext<InboundWebhookConnectionConfigInputs>();

  const secretKey = `${environment}Config.${secretConfigField}` as const;

  const secretRecord = watch(secretKey);

  const enableSecret = () => {
    setValue(secretKey, { ...secretRecord, secret: false, value: null });
  };

  return (
    <SecretField
      dataLoc={dataLoc}
      enableSecret={enableSecret}
      helpText={helpText}
      isErrored={isErrored}
      isRequired={isRequired}
      isSecret={Boolean(secretRecord.secret)}
      register={register}
      secretKey={`${secretKey}.value`}
      secretName={secretName}
    />
  );
};
